import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";

// img
// import i1 from "@/Assets/images/authbg.png";
import i1 from "../../../../Assets/images/user.png";

import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import { z } from "zod";
import Loading from "../../../../components/Common/Loading";
import Toggle from "../../../../components/Common/Toggle";
import {
  ADD_USER,
  GET_USER_BY_ID,
  UPDATE_USER,
} from "../../../../services/ApiCalls";
import { accountType, activeInActiveArr } from "../../../../utilities/const";
import fileUploader from "../../../../utilities/fileUploader";
import {
  catchAsync,
  checkResponse,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";
import GoogleAutocomplete from "../../../../components/Common/GoogleAutoComplete";

const getSchema = (editMode) =>
  z
    .object({
      fname: z.string().min(1, { message: "First Name is required" }),
      lname: z.string().min(1, { message: "Last Name is required" }),
      email: z
        .string()
        .min(1, { message: "Email is required" })
        .email("Invalid email address"),
      password: z.string().optional(),
      contactNumber: z.string().min(1, { message: "Phone number is required" }),
      countryCode: z.string({ required_error: "Country Code is Required" }),
      address: z.string().min(1, { message: "Address is required" }),
      lat: z.number({ required_error: "Address is required" }),
      lng: z.number({ required_error: "Address is required" }),
      status: z.nativeEnum(activeInActiveArr, {
        message: "This field is required",
        required_error: "This field is required",
        invalid_type_error: "This field is required!",
      }),
      // accountType: z.string(),
      passwordToggle: z.boolean(), // this for the edit mode
    })
    .refine(
      (data) => {
        if (!editMode) {
          if (data.password === "") {
            return false;
          }
        }
        if (data.passwordToggle && data.password === "") {
          return false;
        }
        return true;
      },
      { message: "Password is required", path: ["password"] }
    );

const AddEditUser = () => {
  const [loader, setLoader] = useState(false);
  const [profileImage, setProfileImage] = useState({});
  console.log(profileImage, "profileImageprofileImage");

  const { id } = useParams();
  const [userDetails, setUserUserDetails] = useState();
  const [profileImageLoader, setProfileImageLoader] = useState(false);
  const [showProfile, setshowProfile] = useState(false);

  const schema = useMemo(() => getSchema(id), [id]);
  const [showPassWord, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      status: "active",
      passwordToggle: false,
      address: "",
    },
    values: {
      status: userDetails?.status || "active",
      contactNumber: userDetails?.countryCode + userDetails?.mobileNumber || "",
      // accountType: userDetails?.accountType || accountType[0],
      email: userDetails?.email || "",
      countryCode: userDetails?.countryCode || "",
      address: userDetails?.address || "",
      lat: userDetails?.userLocation?.coordinates[1] || 0,
      lng: userDetails?.userLocation?.coordinates[0] || 0,
      fname: userDetails?.fname || "",
      lname: userDetails?.lname || "",
      passwordToggle: false,
    },
  });

  const submitHandler = catchAsync(async (data) => {
    if (!profileImage?.link) {
      return toast.error("Profile image is required");
    }
    setLoader(true);

    const body = {
      ...data,
      ...(id && { _id: id }),
      profileImage: profileImage.link,
      mobileNumber: data.contactNumber.replace(data.countryCode, ""),
    };

    delete body.passwordToggle;

    const res = await (id ? UPDATE_USER(body) : ADD_USER(body));

    const success = checkResponse({ res, showSuccess: true });

    if (success) {
      navigate("/manage-user");
      setLoader(false);
    } else {
      setLoader(false);
    }
  });

  const profileImageHandler = catchAsync(async (e) => {
    setProfileImageLoader(true);
    setshowProfile(true);

    const res = await fileUploader(e.target.files[0]);

    if (!res?._id) {
      setProfileImageLoader(false);
      return;
    }

    setProfileImageLoader(false);

    setProfileImage(res);
  });

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_USER_BY_ID(id);
    const success = checkResponse({
      res,
      setData: setUserUserDetails,
      setLoader,
    });
    if (success) setProfileImage(res?.data?.data?.profileImage);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const handleCancel = () => {
    navigate("/manage-user");
  };

  const addressChangeHandler = (address) => {
    setValue("address", address?.address, { shouldValidate: true });
    setValue("lat", address?.lat, { shouldValidate: true });
    setValue("lng", address?.lng, { shouldValidate: true });
  };

  return (
    <>
      {loader && <Loader />}
      <section className="editUser position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/manage-user"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  {id ? "Edit User" : "Add New User"}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ border: "1px solid #dee2e6" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row className="justify-content-between">
                    <Col lg="12" className="my-2">
                      <div
                        className="mx-auto position-relative upload text-center"
                        style={{ maxWidth: "max-content" }}
                      >
                        <input
                          type="file"
                          className="file position-absolute h-100 w-100"
                          onChange={profileImageHandler}
                        />
                        <div className="imgWrp position-relative">
                          <span
                            className="icn position-absolute"
                            style={{ right: 0, bottom: 20 }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="22"
                              viewBox="0 0 26 26"
                              fill="none"
                            >
                              <circle
                                cx="13.2007"
                                cy="12.9282"
                                r="12.3872"
                                fill="#3366FF"
                              />
                              <path
                                d="M9.68021 16.69C9.79021 16.69 9.81221 16.679 9.91121 16.657L11.8912 16.261C12.1002 16.206 12.3092 16.107 12.4742 15.942L17.2702 11.146C18.0072 10.409 18.0072 9.14404 17.2702 8.40704L16.8632 7.97804C16.1262 7.24104 14.8502 7.24104 14.1132 7.97804L9.31721 12.785C9.16321 12.939 9.05321 13.159 8.99821 13.368L8.58021 15.37C8.52521 15.744 8.63521 16.107 8.89921 16.371C9.10821 16.58 9.41621 16.69 9.68021 16.69ZM10.0542 13.577L14.8502 8.77004C15.1692 8.45104 15.7522 8.45104 16.0602 8.77004L16.4782 9.18804C16.8522 9.56204 16.8522 10.09 16.4782 10.453L11.6932 15.26L9.65821 15.601L10.0542 13.577ZM17.2262 17.372H9.10821C8.78921 17.372 8.58021 17.581 8.58021 17.9C8.58021 18.219 8.84421 18.428 9.10821 18.428H17.1822C17.5012 18.428 17.7652 18.219 17.7652 17.9C17.7542 17.581 17.4902 17.372 17.2262 17.372Z"
                                fill="#F2F2F7"
                                stroke="#F8FAFC"
                                stroke-width="0.3"
                              />
                            </svg>
                          </span>
                          {profileImageLoader ? (
                            <div
                              style={{ height: 140, width: 140 }}
                              className="img-fluid rounded-circle object-fit-cover"
                            >
                              <Loading fullSize={true} />
                            </div>
                          ) : (
                            <img
                              style={{ height: 140, width: 140 }}
                              src={
                                showProfile
                                  ? profileImage?.link
                                  : profileImage || i1
                              }
                              alt=""
                              className="img-fluid rounded-circle object-fit-cover"
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          placeholder="Annette Black"
                          className="form-control"
                          {...register("fname")}
                        />
                        {errors?.fname && (
                          <p className="text-danger m-0">
                            {errors?.fname?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          placeholder="Annette Black"
                          className="form-control"
                          {...register("lname")}
                        />
                        {errors?.lname && (
                          <p className="text-danger m-0">
                            {errors?.lname?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          placeholder="jackson.graham@example.com"
                          className="form-control"
                          {...register("email")}
                        />

                        {errors?.email && (
                          <p className="text-danger m-0">
                            {errors?.email?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Phone Number
                        </label>
                        <Controller
                          control={control}
                          name="contactNumber"
                          render={({ field }) => {
                            return (
                              <PhoneInput
                                {...field}
                                country={"us"}
                                value={field.value}
                                onChange={(value, { dialCode }) => {
                                  setValue("countryCode", dialCode);
                                  field.onChange(value);
                                }}
                              />
                            );
                          }}
                        />{" "}
                        {errors.countryCode ? (
                          <p className="text-danger m-0">
                            {errors?.countryCode?.message}
                          </p>
                        ) : (
                          errors?.contactNumber && (
                            <p className="text-danger m-0">
                              {errors?.contactNumber?.message}
                            </p>
                          )
                        )}
                      </div>

                      {id && (
                        <div className="py-2">
                          <label
                            htmlFor=""
                            className="form-label fw-sbold text-muted ps-2 m-0"
                          >
                            Change Password
                          </label>
                          <div className="iconWithText switch-md position-relative">
                            <Toggle
                              isChecked={watch("passwordToggle")}
                              onChange={(e) =>
                                setValue("passwordToggle", e.target.checked)
                              }
                            />
                          </div>
                        </div>
                      )}
                      {(!id || watch("passwordToggle")) && (
                        <div className="py-2">
                          <label
                            htmlFor=""
                            className="form-label fw-sbold text-muted ps-2 m-0"
                          >
                            Password
                          </label>
                          <div className="iconWithText position-relative">
                            <input
                              type={!showPassWord && "password"}
                              placeholder="*******************"
                              className="form-control"
                              {...register("password")}
                            />
                            {errors?.password && (
                              <p className="text-danger m-0">
                                {errors?.password?.message}
                              </p>
                            )}

                            <Button
                              variant="transparent"
                              style={{ right: 10 }}
                              onClick={() => setShowPassword((p) => !p)}
                              className="border-0 p-0 position-absolute icn"
                            >
                              {showPassWord ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 14 11"
                                  fill="none"
                                >
                                  <path
                                    d="M8.96236 5.23432C8.96236 5.60618 8.8521 5.96968 8.64551 6.27886C8.43892 6.58804 8.14529 6.82902 7.80174 6.97132C7.4582 7.11362 7.08017 7.15085 6.71546 7.07831C6.35076 7.00576 6.01576 6.8267 5.75282 6.56376C5.48988 6.30082 5.31082 5.96582 5.23827 5.60112C5.16573 5.23641 5.20296 4.85838 5.34526 4.51484C5.48756 4.17129 5.72854 3.87766 6.03772 3.67107C6.34691 3.46448 6.71041 3.35422 7.08226 3.35422C7.58089 3.35422 8.0591 3.5523 8.41169 3.90489C8.76428 4.25748 8.96236 4.73569 8.96236 5.23432ZM13.8945 5.54768C13.7817 5.73569 11.1621 10.2479 7.08226 10.2479C3.00242 10.2479 0.382804 5.73569 0.269997 5.54768C0.214993 5.45241 0.186035 5.34433 0.186035 5.23432C0.186035 5.12432 0.214993 5.01624 0.269997 4.92097C0.382804 4.73296 3.00242 0.220703 7.08226 0.220703C11.1621 0.220703 13.7817 4.73296 13.8945 4.92097C13.9495 5.01624 13.9785 5.12432 13.9785 5.23432C13.9785 5.34433 13.9495 5.45241 13.8945 5.54768ZM10.2158 5.23432C10.2158 4.61457 10.032 4.00874 9.68768 3.49344C9.34336 2.97813 8.85397 2.5765 8.2814 2.33934C7.70882 2.10217 7.07878 2.04011 6.47094 2.16102C5.8631 2.28193 5.30476 2.58037 4.86653 3.0186C4.4283 3.45683 4.12986 4.01516 4.00895 4.62301C3.88804 5.23085 3.9501 5.86089 4.18727 6.43347C4.42443 7.00604 4.82607 7.49543 5.34137 7.83975C5.85667 8.18406 6.46251 8.36784 7.08226 8.36784C7.91331 8.36784 8.71034 8.0377 9.29798 7.45005C9.88563 6.86241 10.2158 6.06538 10.2158 5.23432Z"
                                    fill="#B1B1B1"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 14 11"
                                  fill="none"
                                >
                                  <path
                                    d="M8.96236 5.23432C8.96236 5.60618 8.8521 5.96968 8.64551 6.27886C8.43892 6.58804 8.14529 6.82902 7.80174 6.97132C7.4582 7.11362 7.08017 7.15085 6.71546 7.07831C6.35076 7.00576 6.01576 6.8267 5.75282 6.56376C5.48988 6.30082 5.31082 5.96582 5.23827 5.60112C5.16573 5.23641 5.20296 4.85838 5.34526 4.51484C5.48756 4.17129 5.72854 3.87766 6.03772 3.67107C6.34691 3.46448 6.71041 3.35422 7.08226 3.35422C7.58089 3.35422 8.0591 3.5523 8.41169 3.90489C8.76428 4.25748 8.96236 4.73569 8.96236 5.23432ZM13.8945 5.54768C13.7817 5.73569 11.1621 10.2479 7.08226 10.2479C3.00242 10.2479 0.382804 5.73569 0.269997 5.54768C0.214993 5.45241 0.186035 5.34433 0.186035 5.23432C0.186035 5.12432 0.214993 5.01624 0.269997 4.92097C0.382804 4.73296 3.00242 0.220703 7.08226 0.220703C11.1621 0.220703 13.7817 4.73296 13.8945 4.92097C13.9495 5.01624 13.9785 5.12432 13.9785 5.23432C13.9785 5.34433 13.9495 5.45241 13.8945 5.54768ZM10.2158 5.23432C10.2158 4.61457 10.032 4.00874 9.68768 3.49344C9.34336 2.97813 8.85397 2.5765 8.2814 2.33934C7.70882 2.10217 7.07878 2.04011 6.47094 2.16102C5.8631 2.28193 5.30476 2.58037 4.86653 3.0186C4.4283 3.45683 4.12986 4.01516 4.00895 4.62301C3.88804 5.23085 3.9501 5.86089 4.18727 6.43347C4.42443 7.00604 4.82607 7.49543 5.34137 7.83975C5.85667 8.18406 6.46251 8.36784 7.08226 8.36784C7.91331 8.36784 8.71034 8.0377 9.29798 7.45005C9.88563 6.86241 10.2158 6.06538 10.2158 5.23432Z"
                                    fill="#B1B1B1"
                                  />
                                  <line
                                    x1="1"
                                    y1="1"
                                    x2="13"
                                    y2="10"
                                    stroke="#B1B1B1"
                                    strokeWidth="1.5"
                                  />
                                </svg>
                              )}
                            </Button>
                          </div>
                        </div>
                      )}
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2 d-none">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Account Type
                        </label>
                        <Controller
                          control={control}
                          name="accountType"
                          render={({ field }) => {
                            return (
                              <Form.Select
                                {...field}
                                className="form-control"
                                aria-label="Default select example"
                              >
                                {accountType.map((item) => {
                                  return (
                                    <option value={item?.value}>
                                      {removeUnderScoreAndCapitalizeFirstLetter(
                                        item?.label
                                      )}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                            );
                          }}
                        />
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Address
                        </label>
                        {/* <textarea
                          name=""
                          rows={7}
                          id=""
                          className="form-control h-auto"
                          {...register("address")}
                        ></textarea> */}

                        <GoogleAutocomplete
                          lat={watch("lat")}
                          lng={watch("lng")}
                          name={"address"}
                          address={watch("address")}
                          onChange={addressChangeHandler}
                        />
                        {errors?.address && (
                          <p className="text-danger m-0">
                            {errors?.address?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Status
                        </label>
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10  ps-2 flex-wrap">
                          {activeInActiveArr.map((item) => {
                            return (
                              <li className="d-flex align-items-center">
                                <input
                                  type="radio"
                                  id={item}
                                  name="status"
                                  value={item}
                                  className="form-check"
                                  {...register("status")}
                                />
                                <label
                                  htmlFor={item}
                                  className="form-label fw-sbold text-muted ps-2 m-0"
                                >
                                  {removeUnderScoreAndCapitalizeFirstLetter(
                                    item
                                  )}
                                </label>
                              </li>
                            );
                          })}
                        </ul>
                        {errors?.status && (
                          <p className="text-danger m-0">
                            {errors?.status?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Link to="/manage-user">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                            type="button"
                          >
                            Back
                          </Button>
                        </Link>
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn "
                          type="submit"
                          disabled={profileImageLoader}
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddEditUser;
